import { useMutation } from '@tanstack/react-query';
import { apiHelpers, parseApiResponse } from '@/api/core';
import type { CreateInquiryRequest } from '@packages/types/support/dto';

/**
 * 고객 문의 발송 훅.
 * 공개 엔드포인트(support.inquiry)로 문의 내용을 운영팀에 메일 발송한다.
 */
export function useSendInquiry() {
  return useMutation({
    mutationFn: async (payload: CreateInquiryRequest) => {
      const res = await apiHelpers.post('support.inquiry', payload);
      const parsed = parseApiResponse(res);
      if (parsed.error) {
        throw new Error(parsed.error.message || 'Unknown error');
      }
    },
  });
}
